import ContactItem from "../../../Domain/ContactItem";
import InputTypesEnum from "../../../Enums/InputTypesEnum";
import ValidityHelper from "../../../Helpers/ValidityHelper";
import contactService from "../../../Services/contactService";
import selectHelper from "../../../Helpers/selectHelper";

export default class EditContactWindowDescription {
  static titleForCreate = 'Add New Contact';
  static titleForEdit = 'Edit Contact';
  static itemType = ContactItem;
  static serviceFunction = (edited) => contactService.EditContact(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Basic information',
      fields: [
        {
          fieldName: 'FirstName',
          label: 'First Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'LastName',
          label: 'Last Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Birthday',
          label: 'Birthday',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.ContactId !== '',
        },
        {
          fieldName: 'Vatnumber',
          label: 'VAT Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.validityCheckerforVatNumber,
        },
        {
          fieldName: 'BillToClientName',
          label: 'Bill To Client Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
    {
      label: 'Relevant information',
      fields: [
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => item.hide === true || item.ContactId !== '',
        },
        {
          fieldName: 'JobTitle',
          label: 'Job Title',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'WebSiteUrl',
          label: 'Web Site URL',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'TimeZoneOffset',
          label: 'Time Zone',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: selectHelper.getTimeZoneOptions(),
        },
      ],
    },
    {
      label: 'Contact information',
      fields: [
        {
          fieldName: 'BusinessPhone',
          label: 'Business Phone',
          className: 'col-12',
          type: InputTypesEnum.BusinessPhone,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'MobilePhone',
          label: 'Mobile Phone',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OtherPhone',
          label: 'Other Phone',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'HomePhone',
          label: 'Home Phone',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Fax',
          label: 'Fax',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Email',
          label: 'Email',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
    {
      label: 'Address information',
      fields: [
        {
          fieldName: 'AddressId',
          label: 'Address',
          className: 'col-12',
          type: InputTypesEnum.SelectAddressWithInformationByEntityType,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.ClientId === '',
          EntityTypeId: '7',
          EntityId: 'ClientId',
          disableClearButton: true,
        },
        {
          fieldName: 'Comments',
          label: 'Comments',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
    {
      label: 'Consent information',
      fields: [
        {
          fieldName: 'PrefContactMethodCode',
          label: 'Preferred Contact Method',
          className: 'col-12',
          type: InputTypesEnum.CommonContactMethodLookupItemSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowBulkEmail',
          label: 'Allow Bulk Email',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowEmail',
          label: 'Allow Email',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowFax',
          label: 'Allow Fax',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowPhone',
          label: 'Allow Phone',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowPostalMail',
          label: 'Allow Postal Mail',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowSendMedia',
          label: 'Allow Social Media',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
